/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgRideEndorsement32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M15.271 11.249a2.121 2.121 0 01-1.247.498.615.615 0 01-.359-1.128l.042-.028c.581-.395 1.032-.94 1.426-1.54l.003-.005a.877.877 0 01.99-.348c.37.116.623.464.623.857v6.534h-1.477v-4.84z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M15.888 1.476a.124.124 0 01.112-.07c.047 0 .09.027.112.07l3.271 6.581a.494.494 0 00.372.264s6.06.83 7.398 1.012a.126.126 0 01.069.216l-5.376 5.074a.482.482 0 00-.142.428l1.304 7.203a.126.126 0 01-.181.134l-6.597-3.442a.498.498 0 00-.46 0l-6.597 3.441a.126.126 0 01-.181-.133l1.304-7.203a.473.473 0 00-.142-.428L4.778 9.55a.125.125 0 01.069-.216l7.398-1.011a.494.494 0 00.371-.265l3.272-6.581v0z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M8.445 24.111l-2.78 4.832M7.649 14.988c-1.094 2.856-2.66 5.208-4.602 7.159M23.488 24.111l2.781 4.832M24.285 14.988c1.094 2.856 2.66 5.208 4.602 7.159M16 21.5v9.44'
      />
    </svg>
  );
}

export default SvgRideEndorsement32;
